import { render } from "./LoadsheddingView.vue?vue&type=template&id=90f1a446"
import script from "./LoadsheddingView.vue?vue&type=script&lang=js"
export * from "./LoadsheddingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__